<template>
  <div class="error-403">
  <div class="content">
    <div class="bk_403"></div>
    <div class="desc">Error Forbidden~ 没有权限，请联系管理员 <button @click="back">返回首页</button></div>
  </div>
  <div class="bk2"></div>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'e403',
  methods: {
    back () {
      this.$router.push({name: 'login'})
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/error/e403/index.vue